import { defineMessages } from 'react-intl';

export default defineMessages({
  '10off' : {
    id: 'coupontype.10off.title',
    defaultMessage: '$10 off'
  },
  '20off' : {
    id: 'coupontype.20off.title',
    defaultMessage: '$20 off'
  },
});
